/* eslint-disable */
<template>
  <div class="locations-and-regions">
    <AdminNavigation ref="navigation" indexProps="9" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Locations</h1></div>
        <div class="header-sub-title">Locations are available for Specialists to operate from. Ensure a region is attached to a location.</div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="2-3" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Location Name" v-model="listParam.LocationName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Region Name" v-model="listParam.RegionName"/>
              <router-link to="/admin-manage-location">
                <v-btn class="add-icon" dark>Add New</v-btn>
              </router-link>
            </div>
          </div>
        </div>
        <div class="content-scroll-x">
          <div>
            <el-table @row-click="RowClick" :default-sort="{prop: 'LocationName', order: 'ascending'}" :data="allLocations" stripe @sort-change="sortParam" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="250"
                  show-overflow-tooltip
                  label="Location Name"
                  sortable="custom"
                  prop="LocationName"
              >
                <template slot-scope="scope">
                  <span>{{decodeURIComponent(scope.row.LocationName)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="250"
                  show-overflow-tooltip
                  label="Address"
                  sortable="custom"
                  prop="Address"
              >
                <template slot-scope="scope">
                  <Span>{{decodeURIComponent(scope.row.AddressLine1 + ' ' + scope.row.AddressLine2)}}</Span>
                </template>
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  label="Region"
                  sortable="custom"
                  prop="Region"
              >
                <template slot-scope="scope">
                  <span>{{decodeURIComponent(scope.row.City.Region.RegionName)}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :class="listParam.pageNum === item ? 'selected' : ''" :value="item" :key="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount/listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import utilities from '@/assets/js/utilities'
  import AdminNavigation from '@/components/AdminNavigation'
  import AdminSettingsMenu from '@/components/AdminSettingsMenu'
  import Header from '@/components/Header'
  import { debounce } from 'lodash';

  export default {
    name: 'AdminLocationsAndRegions',
    components: {
      AdminNavigation,
      AdminSettingsMenu,
      Header,
    },
    data() {
      return {
        hasError: false,
        totalCount: 0,
        errorMessage: 'Please correct the errors shown above and try again.',
        locations: [],
        allLocations: [],
        limit: 10,
        pagination: utilities.initPagination(),
        listParam: {
          pageSize: 10,
          pageNum: 1,
          LocationName: '',
          orderBy: 'LocationName',
          ascOrDesc: 'ASC'
        },
        successMessage: '',
        searchTerm: '',
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/getUser'];
      },
    },
    methods: {
      RowClick(e) {
        this.$router.push('/admin-manage-location?locationId='+e.LocationID)
      },
      sortParam( v ) {
        this.listParam.orderBy = v.prop
        if(v.order === "ascending") {
          this.listParam.ascOrDesc = 'ASC'
        } else if (v.order === "descending") {
          this.listParam.ascOrDesc = 'DESC'
        } else {
          this.listParam.orderBy = null
          this.listParam.ascOrDesc = null
        }

        this.selectPage(1)
      },

      search: debounce(function () {
        this.selectPage(1)
      }, 800),

      async loadData() {
        const {data, total} = await utilities.getLocationsNew(this.listParam)
        this.allLocations = data
        this.totalCount = total
      },

      getFullAddress(location) {
        return (
          location.address1 +
          (location.address1 != '' && location.address2 != '' ? ' ' : '') +
          location.address2 +
          (location.address1 != '' || location.address2 != '' ? ', ' : '') +
          location.cityName +
          (location.cityName != '' ? ', ' : '') +
          location.state +
          ' ' +
          location.postcode
        )
      },

      selectPage(index) {
        this.listParam.pageNum = index
        this.loadData()
      },
    },
    async beforeMount() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      await this.loadData();
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
    mounted() {

    },
  }
</script>
